import { Link } from 'react-router-dom';
import { heroArticles } from '@/mocks/home';

export default function SubHeroSection() {
  const subArticles = heroArticles.slice(1);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {subArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group relative h-64 md:h-72 rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src={article.image}
                alt={`51黑料网 - ${article.title}`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                title={article.title}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/95 via-background-50/30 to-transparent"></div>

              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-0.5 rounded text-[10px] font-medium bg-accent-500/80 text-foreground-50 mb-3">
                  {article.category}
                </span>
                <h3 className="text-base md:text-lg font-semibold text-foreground-50 line-clamp-2 leading-snug group-hover:text-accent-400 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-400 line-clamp-2">{article.excerpt}</p>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(article.views / 1000).toFixed(1)}k
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}